import { useState } from 'react';
import * as XLSX from 'xlsx';

export type TerritoryDates = Record<string, string>;

function normalizeHeader(header: string): string {
    return header.replace(/\s+/g, ' ').replace(/\n/g, ' ').trim().toLowerCase();
}

export const useTerritoryDates = () => {
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [territoryDates, setTerritoryDates] = useState<TerritoryDates>({});

    const handleFile = (file: File) => {
        setLoading(true);
        setError(null);
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target?.result as ArrayBuffer);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheet = workbook.Sheets[workbook.SheetNames[0]];
                const json = XLSX.utils.sheet_to_json(sheet, { header: 1 }) as any[][];
                // Busca la fila de encabezados
                let numCol = -1, fechaCol = -1;
                for (let i = 0; i < json.length; i++) {
                    const row = json[i].map((x: any) => normalizeHeader(x || ''));
                    // Busca por coincidencia parcial
                    numCol = row.findIndex(h => h.includes('num de terr'));
                    fechaCol = row.findIndex(h => h.includes('ultima fecha') && h.includes('completo'));
                    if (numCol !== -1 && fechaCol !== -1) {
                        // Procesa las filas siguientes
                        const map: TerritoryDates = {};
                        for (let j = i + 1; j < json.length; j++) {
                            const n = json[j][numCol];
                            const f = json[j][fechaCol];
                            if (n && f) {
                                map[n.toString().trim()] = f.toString().trim();
                            }
                        }
                        setTerritoryDates(map);
                        setLoading(false);
                        return;
                    }
                }
                setError('No se encontraron columnas válidas en el archivo.');
                setLoading(false);
            } catch (err) {
                setError('Error al procesar el archivo.');
                setLoading(false);
            }
        }
        reader.readAsArrayBuffer(file);
    }

    return { territoryDates, loading, error, handleFile };
}
